<template>
  <div class="us_app">
    <section class="user_section">
      <div class="title jc">
        <h2>비방사용 리뷰관리</h2>
      </div>

      <article class="view cmnity">
        <div class="search_box" style="flex-wrap: wrap">
          <div class="flex items-center justify-between w100">
            <p class="mb0">
              리뷰를 남길 비방이
              <strong> {{ formulaLibraryReviewList.length }} </strong>건 있습니다.
            </p>
            <button class="btn btn_md btn_darkbrown" @click="fn_search">조회</button>
          </div>
        </div>
        <div class="tab_contents">
          <div class="lay_left">
            <div class="table_list">
              <table class="list">
                <colgroup>
                  <col width="80" />
                  <col width="*" />
                  <col width="150" />
                  <col width="150" />
                  <col width="150" />
                  <col width="150" />
                  <col width="150" />
                  <col width="150" />
                  <col width="120" />
                </colgroup>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>비방처방명</th>
                    <th>질병카테고리</th>
                    <th>상세카테고리</th>
                    <th>환자명</th>
                    <th>성별</th>
                    <th>나이</th>
                    <th>처방일시</th>
                    <th>리뷰</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="formulaLibraryReviewList.length == 0">
                    <td colspan="9"><span>작성할 비방 리뷰가 없습니다.</span></td>
                  </tr>
                  <tr
                    v-for="(item, index) in formulaLibraryReviewList"
                    :key="index"
                  >
                    <td>
                      <span>{{ searchInfo.pageInfo.totPage - ( (searchInfo.pageInfo.page - 1) * searchInfo.pageInfo.pageSize) - index}}</span>
                    </td>
                    <td class="ac">
                      <span>{{ item.prescribe_nm }}</span>
                    </td>
                    <td>
                      <span>{{ item.prescribe_category_nm }}</span>
                    </td>
                    <td>
                      <span>{{ item.prescribe_sub_category_nm }}</span>
                    </td>
                    <td>
                      <span>{{ item.patient_nm }}</span>
                    </td>
                    <td>
                      <span>{{ item.patient_gender_nm }}</span>
                    </td>
                    <td>
                      <span>{{ item.patient_age }}</span>
                    </td>
                    <td>
                      <span>{{ item.payment_complete_dt }}</span>
                    </td>
                    <td>
                      <div class="flex justify-center">
                        <button class="bdge bd_brown" @click="fn_open_review(item)">리뷰작성</button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <Pagination :pageInfo="searchInfo.pageInfo" @clickPage="movePage" v-show="pagingShow"/>
          </div>
        </div>
      </article>
    </section>

    <bibang-review-reg-modal ref="bibangReviewRegModal" @saved="fn_search" />
  </div>
</template>

<script>

import axios from 'axios'
import commonUtil from "@/mixin/commonUtil";
import Pagination from "@/components/AdminPagination.vue"
import BibangReviewRegModal from "@/modal/user/bibangReviewRegModal.vue";

export default {
  components: {
    Pagination,
    BibangReviewRegModal
  },
  mixins: [commonUtil],
  data() {
    return {
      searchInfo : {
          clinic_doctor_id : '',
          pageInfo : {
              page : 1,
              pageSize : 10,
              totPage : 0
          }
      },
      pagingShow : false,
      formulaLibraryReviewList: [],
    };
  },
  created(){
      this.searchInfo.clinic_doctor_id = this.$store.getters['clinicDoctorInfo/getClinicDoctorId'];
  },
  mounted(){
    this.fn_search();
  },
  methods : {
    fn_search(){

      console.log("@@@@@@ this.searchInfo : %o",this.searchInfo);

      axios
          .post("/api/user/hanidata/getFormulaLibraryReviewList", this.searchInfo)
          .then((res) => {
              console.log("@@@@ res : %o",res);
              this.formulaLibraryReviewList = res.data.formulaLibraryReviewList;

              if(this.searchInfo.pageInfo.totPage> 0){
                  this.pagingShow = true;
              }else{
                  this.pagingShow = false;
              }

          })
          .catch((err) => console.log(err));
      },
    movePage(page){
        this.searchInfo.pageInfo.page = page;
        this.fn_search();
    },
    fn_open_review(item){
      this.$refs.bibangReviewRegModal.open(item, this.searchInfo.clinic_doctor_id);
    },
  }

};
</script>